// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "wrapper-J2Fgw";
var _3 = "flightInfo-1BOdj";
var _4 = "flightInfo__iatas-d0FCD";
var _5 = "planeIcon-3e7B7";
var _6 = "flightInfo__cities-3hLy7";
var _7 = "flightInfo__time-2E5fT";
var _8 = "fareGroup-2oxYz";
var _9 = "fareGroup__img-1sqTq";
var _a = "fareGroup__info-28FYr";
var _b = "fareGroup_flight-1yjI-";
var _c = "arrivalInfo-1lLDe";
var _d = "arrivalInfo__place-dRwVv";
var _e = "arrivalInfo__item-2Pdbo";
var _f = "arrivalInfo__title-1upu-";
export { _1 as "__esModule", _2 as "wrapper", _3 as "flightInfo", _4 as "flightInfo__iatas", _5 as "planeIcon", _6 as "flightInfo__cities", _7 as "flightInfo__time", _8 as "fareGroup", _9 as "fareGroup__img", _a as "fareGroup__info", _b as "fareGroup_flight", _c as "arrivalInfo", _d as "arrivalInfo__place", _e as "arrivalInfo__item", _f as "arrivalInfo__title" }
export default { "__esModule": _1, "wrapper": _2, "flightInfo": _3, "flightInfo__iatas": _4, "planeIcon": _5, "flightInfo__cities": _6, "flightInfo__time": _7, "fareGroup": _8, "fareGroup__img": _9, "fareGroup__info": _a, "fareGroup_flight": _b, "arrivalInfo": _c, "arrivalInfo__place": _d, "arrivalInfo__item": _e, "arrivalInfo__title": _f }
